import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";
//获取用户信息
//获取用户信息
export function userApiMemberSingleFindUserContent() {
  return omniAxios({
    url: config.userApiMemberSingleFindUserContentPath,
    method: "get",
    params: {},
  });
}
export function buryPointUserBehaviorInsertRecord(params) {
  return omniAxios({
    url: config.buryPointUserBehaviorInsertRecordPath,
    method: "post",
    params,
    isTracker:true,
    useDevServerProxy:true
  });
}
//1.0获取gjxx列表三分类
export function apiV1SemGetTargetsByCids(params) {
  return omniAxios({
    url: config.apiV1SemGetTargetsByCidsPath,
    method: "get",
    params,
    isOnePointZeroSearchInterfaceApi:true
  });
}
